import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae8c6d0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_section" }
const _hoisted_2 = { class: "showOnlyMobile" }
const _hoisted_3 = ["data-url"]
const _hoisted_4 = { class: "showOnlyWeb" }
const _hoisted_5 = ["data-url"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<section class=\"desc_section\" data-v-ae8c6d0c><p class=\"title\" data-v-ae8c6d0c>상설특가제란?</p><p class=\"desc\" data-v-ae8c6d0c><span class=\"bold\" data-v-ae8c6d0c> 누구나 언어의 장벽을 넘어 <span class=\"showOnlyMobile\" data-v-ae8c6d0c><br data-v-ae8c6d0c></span> 새로운 세상을 만나게 하기 위한 </span><span class=\"\" data-v-ae8c6d0c><br data-v-ae8c6d0c></span> 링고라만의 특별한 가격 제도로, <span class=\"showOnlyMobile\" data-v-ae8c6d0c><br data-v-ae8c6d0c></span> 업계 최저가 기준에 맞추어 <span class=\"showOnlyWeb\" data-v-ae8c6d0c><br data-v-ae8c6d0c></span><span class=\"purple\" data-v-ae8c6d0c><b data-v-ae8c6d0c> 상시 판매 가격을 <span class=\"showOnlyMobile\" data-v-ae8c6d0c><br data-v-ae8c6d0c></span> 정가 대비 최대 50% 이상 할인 </b></span><span data-v-ae8c6d0c>하고 있습니다.</span></p></section>", 1)
const _hoisted_7 = { class: "low_price_section" }
const _hoisted_8 = ["data-url"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 1:1 원어민 회화 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 업계 최저가 보장 ")
], -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 링고라는 교육 전문 튜터와의 1:1 원어민 회화를 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 가장 저렴하게 제공합니다. ")
], -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc_text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "비교 기준"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 링고라와 동일한 조건의 1:1 원어민 회화 수업 ")
], -1 /* HOISTED */))
const _hoisted_12 = ["data-url"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "button_title",
  style: {"margin-bottom":"12px"}
}, "대표 수강권 가격 비교", -1 /* HOISTED */))
const _hoisted_14 = ["data-url"]
const _hoisted_15 = { class: "compare_tab" }
const _hoisted_16 = { class: "compare_tutor_section" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 1회 20분 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 수업당 가격 비교 ")
], -1 /* HOISTED */))
const _hoisted_19 = ["data-url"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "12개월 주 2회(96회) 20분 수업 수강권 기준", -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 정가 대비 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 할인율 및 상시 판매가 ")
], -1 /* HOISTED */))
const _hoisted_22 = ["data-url"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "12개월 주 2회(96회) 20분 수업 수강권 기준", -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 업체별 1회 수업 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 가격 비교표 ")
], -1 /* HOISTED */))
const _hoisted_25 = ["data-url"]
const _hoisted_26 = ["data-url"]
const _hoisted_27 = ["data-url"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 1회 20분 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 수업당 가격 비교 ")
], -1 /* HOISTED */))
const _hoisted_30 = ["data-url"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "6개월 주 3회(72회) 20분 수업 수강권 기준", -1 /* HOISTED */))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 정가 대비 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 할인율 및 상시 판매가 ")
], -1 /* HOISTED */))
const _hoisted_33 = ["data-url"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, "6개월 주 3회(72회) 20분 수업 수강권 기준", -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 업체별 1회 수업 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 가격 비교표 ")
], -1 /* HOISTED */))
const _hoisted_36 = ["data-url"]
const _hoisted_37 = ["data-url"]
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<section class=\"compare_notice_section\" data-v-ae8c6d0c><div class=\"container\" data-v-ae8c6d0c><p class=\"title\" data-v-ae8c6d0c>가격비교 기준</p><ul data-v-ae8c6d0c><li class=\"list__item\" data-v-ae8c6d0c>수강권 가격은 표기된 날짜 기준으로 비교하였으며 수시로 업데이트됩니다.</li><li class=\"list__item\" data-v-ae8c6d0c>추가 할인 쿠폰 및 프로모션이 적용되지 않은 상시 판매가로 비교하였습니다.</li><li class=\"list__item\" data-v-ae8c6d0c> 동일 기간, 동일 튜터 타입 수강권의 판매가로 비교하되, 만약 수업 시간이나 기간 내 수업 횟수 등 구성이 다른 수강권만 존재하는 경우에는 총 수업 분수가 가장 유사한 수강권으로 비교하며, 분당 가격 기준 링고라 판매 수강권과 동일한 조건으로 금액 환산하여 가격을 비교하였습니다. </li><li class=\"list__item\" data-v-ae8c6d0c> 링고라의 경우 모든 시간대에 실시간 수업이 가능하기 때문에 특정 시간대나 요일 수업 조건부 할인이 적용되지 않은 상시 이용 조건의 수강권으로만 비교하였습니다. </li><li class=\"list__item\" data-v-ae8c6d0c> 상시 수업 가능한 수강권이 없는 경우, 새벽 시간대 제외 (KST 0시 ~ 6시) 모든 시간대 수업의 가격이 동일한 수강권으로만 비교하였습니다. </li><li class=\"list__item\" data-v-ae8c6d0c>글로벌(Global) 튜터: 영어 사용국 출신 튜터 수업을 의미합니다.</li><li class=\"list__item\" data-v-ae8c6d0c>가격 비교 및 최저가 정책은 글로벌 튜터 음성회화 수강권이 한하여 적용됩니다</li></ul></div></section>", 1)
const _hoisted_39 = { class: "question_section" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "q" }, "Q."),
  /*#__PURE__*/_createTextVNode(" 왜 수강권을 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 저렴하게 판매하나요? ")
], -1 /* HOISTED */))
const _hoisted_41 = { class: "card" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bold_text" }, [
  /*#__PURE__*/_createTextVNode(" \"경제력이 교육을 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 지배하지 않는 세상을 만든다.\" ")
], -1 /* HOISTED */))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "normal_text" }, [
  /*#__PURE__*/_createTextVNode(" 보다 많은 분들이 최고 수준의 1:1 회화 서비스를 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 경험할 수 있도록 기술 혁신을 통해 합리적인 가격으로 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 서비스를 제공하고 있습니다. ")
], -1 /* HOISTED */))
const _hoisted_44 = ["data-url"]
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-ae8c6d0c><p class=\"q\" data-v-ae8c6d0c>Q.</p> 가격이 저렴하면 <br data-v-ae8c6d0c> 퀄리티가 안 좋은거 아닌가요? <br data-v-ae8c6d0c></div><div class=\"card\" data-v-ae8c6d0c><div class=\"normal_text\" style=\"margin-bottom:0;\" data-v-ae8c6d0c> 그렇지 않습니다! 기술 혁신을 통해 <br data-v-ae8c6d0c><b data-v-ae8c6d0c>불필요한 비용을 절감</b> 했기 때문에 1:1 수업을 <br data-v-ae8c6d0c> 합리적인 가격에 판매할 수 있습니다. </div></div><div class=\"title\" data-v-ae8c6d0c><p class=\"q\" data-v-ae8c6d0c>Q.</p> 기술 혁신이 <br data-v-ae8c6d0c> 어떻게 비용을 절감하나요? </div>", 3)
const _hoisted_48 = { class: "card" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "normal_text" }, [
  /*#__PURE__*/_createTextVNode(" 콜센터 두고 튜터를 상주시키는 기존의 전화영어 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 방식은 불필요한 관리 비용을 발생시킵니다. ")
], -1 /* HOISTED */))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "normal_text" }, [
  /*#__PURE__*/_createTextVNode(" 링고라는 "),
  /*#__PURE__*/_createElementVNode("b", null, "효율적인 비용으로 서비스를 운영"),
  /*#__PURE__*/_createTextVNode(" 할 수 있도록 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 기술혁신을 통해 콜센터 없이 운영 가능한 통신 기술과 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 학습 시스템을 마련하였습니다. ")
], -1 /* HOISTED */))
const _hoisted_51 = ["data-url"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small_text" }, [
  /*#__PURE__*/_createTextVNode(" * RTC (Real Time Communication) "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" **규모의 경제 (Economy of scale): "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 생산량이 늘어남에 따라 평균 비용이 줄어드는 현상 ")
], -1 /* HOISTED */))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button_title" }, "운영 방식 비교", -1 /* HOISTED */))
const _hoisted_54 = ["data-url"]
const _hoisted_55 = { class: "report_reward_section" }
const _hoisted_56 = ["data-url"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 최저가 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 신고 보상제 실시 ")
], -1 /* HOISTED */))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "desc",
  style: {"margin-bottom":"40px"}
}, [
  /*#__PURE__*/_createTextVNode(" 링고라보다 저렴한 1:1 원어민 회화 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 수강권을 알려주세요! ")
], -1 /* HOISTED */))
const _hoisted_59 = { class: "card_container" }
const _hoisted_60 = { class: "card" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "STEP. 1", -1 /* HOISTED */))
const _hoisted_62 = ["data-url"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 최저가 보상 기준 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 및 참여자 조건 확인 ")
], -1 /* HOISTED */))
const _hoisted_64 = { class: "card" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "STEP. 2", -1 /* HOISTED */))
const _hoisted_66 = ["data-url"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 양식을 작성하여 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 이메일로 신청 접수 ")
], -1 /* HOISTED */))
const _hoisted_68 = { class: "card" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "STEP. 3", -1 /* HOISTED */))
const _hoisted_70 = ["data-url"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 보상 기준에 따라 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 심사 진행 ")
], -1 /* HOISTED */))
const _hoisted_72 = { class: "card" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "STEP. 4", -1 /* HOISTED */))
const _hoisted_74 = ["data-url"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" 심사 결과에 따라 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "리워드 지급")
], -1 /* HOISTED */))
const _hoisted_76 = /*#__PURE__*/_createStaticVNode("<p class=\"desc\" data-v-ae8c6d0c> 제보한 타사 수강권이 보상 기준에 부합하는 경우, <br data-v-ae8c6d0c> 신고자에게는 <span class=\"purple\" data-v-ae8c6d0c>차액별 상품권</span> 으로 보상해 드리고 <span class=\"showOnlyMobile\" data-v-ae8c6d0c><br data-v-ae8c6d0c></span> 링고라는 업계최저가 기준에 맞추어 가격을 조정합니다. </p><p class=\"button_title\" data-v-ae8c6d0c>최저가 신고 혜택</p><p class=\"desc\" data-v-ae8c6d0c> 링고라보다 저렴한 수강권을 찾아주신 분께 차액만큼 <br data-v-ae8c6d0c> 백화점 상품권으로 보상해 드립니다! </p>", 3)
const _hoisted_79 = ["data-url"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc desc_small" }, [
  /*#__PURE__*/_createTextVNode(" *보상 혜택은 차액 구간별 차등 지급되며 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" '최저가 신고보상제' 안내 페이지에서 상세 내용을 확인하시기 바랍니다. ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNav = _resolveComponent("AppNav")!
  const _directive_img_lazy_loading = _resolveDirective("img-lazy-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" app nav "),
    ($options.appView)
      ? (_openBlock(), _createBlock(_component_AppNav, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("링고라 상설특가제")
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "promotion",
      style: _normalizeStyle({ 'padding-top': $options.appPadding })
    }, [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.main_img_sm,
            class: "main_img_sm",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_3), [
            [_directive_img_lazy_loading]
          ])
        ]),
        _createElementVNode("span", _hoisted_4, [
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.main_img,
            class: "main_img",
            alt: "main_img"
          }, null, 8 /* PROPS */, _hoisted_5), [
            [_directive_img_lazy_loading]
          ])
        ])
      ]),
      _hoisted_6,
      _createElementVNode("section", _hoisted_7, [
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.marketprice_number01,
          class: "img_number",
          alt: "image"
        }, null, 8 /* PROPS */, _hoisted_8), [
          [_directive_img_lazy_loading]
        ]),
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.marketprice_list,
          class: "img_desc",
          alt: "image"
        }, null, 8 /* PROPS */, _hoisted_12), [
          [_directive_img_lazy_loading]
        ]),
        _hoisted_13,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.tab_topdate,
            class: "img_date",
            alt: "image"
          }, null, 8 /* PROPS */, _hoisted_14), [
            [_directive_img_lazy_loading]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: _normalizeClass(["tab_button no-select", { clicked: $data.tab === 'global' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.switchTab('global')))
          }, " 글로벌 튜터 ", 2 /* CLASS */),
          _createCommentVNode(" <button class=\"tab_button no-select\" :class=\"{ clicked: tab === 'native' }\" @click=\"switchTab('native')\">\n          네이티브 튜터\n        </button> ")
        ])
      ]),
      _createElementVNode("section", _hoisted_16, [
        ($data.tab === 'global')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_global_graph01,
                class: "graph",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_19), [
                [_directive_img_lazy_loading]
              ]),
              _hoisted_20,
              _hoisted_21,
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_global_graph02,
                class: "graph",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_22), [
                [_directive_img_lazy_loading]
              ]),
              _hoisted_23,
              _hoisted_24,
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_global_table01,
                class: "table",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_25), [
                [_directive_img_lazy_loading]
              ]),
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_global_table02,
                class: "table",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_26), [
                [_directive_img_lazy_loading]
              ]),
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_global_table03,
                class: "table",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_27), [
                [_directive_img_lazy_loading]
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.tab === 'native')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_native_graph01,
                class: "graph",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_30), [
                [_directive_img_lazy_loading]
              ]),
              _hoisted_31,
              _hoisted_32,
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_native_graph02,
                class: "graph",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_33), [
                [_directive_img_lazy_loading]
              ]),
              _hoisted_34,
              _hoisted_35,
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_native_table01,
                class: "table",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_36), [
                [_directive_img_lazy_loading]
              ]),
              _withDirectives(_createElementVNode("img", {
                "data-url": $data.imgUrls.marketprice_native_table02,
                class: "table",
                alt: "image"
              }, null, 8 /* PROPS */, _hoisted_37), [
                [_directive_img_lazy_loading]
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _hoisted_38,
      _createElementVNode("section", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _hoisted_43,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.reward_img05,
            class: "reward_img",
            alt: "image"
          }, null, 8 /* PROPS */, _hoisted_44), [
            [_directive_img_lazy_loading]
          ])
        ]),
        _hoisted_45,
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _hoisted_50,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.marketprice_system,
            class: "img_system",
            alt: "image"
          }, null, 8 /* PROPS */, _hoisted_51), [
            [_directive_img_lazy_loading]
          ]),
          _hoisted_52,
          _hoisted_53,
          _withDirectives(_createElementVNode("img", {
            "data-url": $data.imgUrls.marketprice_system02,
            class: "img_system02",
            alt: "image"
          }, null, 8 /* PROPS */, _hoisted_54), [
            [_directive_img_lazy_loading]
          ])
        ]),
        _createElementVNode("button", {
          class: "button_start",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.buyCourse()))
        }, "최저가 영어회화 시작")
      ]),
      _createElementVNode("section", _hoisted_55, [
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.marketprice_number02,
          class: "img_number",
          alt: "image"
        }, null, 8 /* PROPS */, _hoisted_56), [
          [_directive_img_lazy_loading]
        ]),
        _hoisted_57,
        _hoisted_58,
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _withDirectives(_createElementVNode("img", {
              "data-url": $data.imgUrls.emoji_01,
              class: "icon",
              alt: "icon"
            }, null, 8 /* PROPS */, _hoisted_62), [
              [_directive_img_lazy_loading]
            ]),
            _hoisted_63
          ]),
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _withDirectives(_createElementVNode("img", {
              "data-url": $data.imgUrls.emoji_02,
              class: "icon",
              alt: "icon"
            }, null, 8 /* PROPS */, _hoisted_66), [
              [_directive_img_lazy_loading]
            ]),
            _hoisted_67
          ]),
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _withDirectives(_createElementVNode("img", {
              "data-url": $data.imgUrls.emoji_03,
              class: "icon",
              alt: "icon"
            }, null, 8 /* PROPS */, _hoisted_70), [
              [_directive_img_lazy_loading]
            ]),
            _hoisted_71
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _withDirectives(_createElementVNode("img", {
              "data-url": $data.imgUrls.emoji_04,
              class: "icon",
              alt: "icon"
            }, null, 8 /* PROPS */, _hoisted_74), [
              [_directive_img_lazy_loading]
            ]),
            _hoisted_75
          ])
        ]),
        _hoisted_76,
        _withDirectives(_createElementVNode("img", {
          "data-url": $data.imgUrls.marketprice_reward,
          class: "img_gift_card",
          alt: "icon"
        }, null, 8 /* PROPS */, _hoisted_79), [
          [_directive_img_lazy_loading]
        ]),
        _hoisted_80,
        _createElementVNode("button", {
          class: "button_detail",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.goToReportRewardSystem()))
        }, "자세히 보기")
      ]),
      ($options.appView)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(["challenge-cta is-info", { 'ani-bottom-up': _ctx.bottomSheetUp }]),
            id: "challengeCta"
          }, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.buyCourse()))
            }, "최저가 수강권 확인")
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */)
  ], 64 /* STABLE_FRAGMENT */))
}